/**
 * Build the page-number window with first/last anchors + ellipses (v1 parity).
 * Pure presentational math — shared by the Find Your Agent results pagination
 * (`agent-results.tsx`, URL-driven) and the profile page's client-state
 * listings/reviews pagination (`profile-pagination.tsx`).
 */
export function pageWindow(
  page: number,
  totalPages: number,
): (number | "ellipsis")[] {
  const siblings = 1;
  const leftSibling = Math.max(page - siblings, 1);
  const rightSibling = Math.min(page + siblings, totalPages);
  const showLeftEllipsis = leftSibling > 2;
  const showRightEllipsis = rightSibling < totalPages - 1;

  const pages: (number | "ellipsis")[] = [];
  if (leftSibling > 1) pages.push(1);
  if (showLeftEllipsis) pages.push("ellipsis");
  for (let i = leftSibling; i <= rightSibling; i++) pages.push(i);
  if (showRightEllipsis) pages.push("ellipsis");
  if (rightSibling < totalPages) pages.push(totalPages);
  return pages;
}
